import React from 'react';
import { Filter, SelectInput, TextInput } from 'react-admin';
import { CustomDateInput } from '../../../../commonComponents/CustomDateInput';
import { BADGE_TIER_CHOICES, BADGE_TYPE_CHOICES, DATE_INPUT_FORMAT } from '../config/constants';

const AchievementSystemReportsFilter = (props) => (
  <Filter {...props}>
    <TextInput label="User ID" source="user_id" alwaysOn />
    <SelectInput
      label="Badge type"
      source="badge_type"
      choices={BADGE_TYPE_CHOICES}
      allowEmpty
      emptyText="All"
      alwaysOn
    />
    <CustomDateInput label="Choose start date" source="start_date" dateFormat={DATE_INPUT_FORMAT} start alwaysOn />
    <CustomDateInput label="Choose end date" source="end_date" dateFormat={DATE_INPUT_FORMAT} end alwaysOn />
    <SelectInput label="Level" source="badge_tier" choices={BADGE_TIER_CHOICES} allowEmpty emptyText="All" alwaysOn />
  </Filter>
);

export default AchievementSystemReportsFilter;
